// extracted by mini-css-extract-plugin
export var attachment = "_qw-a";
export var emailContainer = "_qw-4";
export var emailContentPaddedContainer = "_qw-b";
export var emailHeader = "_qw-6";
export var emailIframe = "_qw-3";
export var emailInfoIcon = "_qw-9";
export var emailShortenedSummary = "_qw-e";
export var infoDropdown = "_qw-0";
export var infoRowBoundedContent = "_qw-d";
export var internal = "_qw-5";
export var merchant = "_qw-8";
export var messageInputContainer = "_qw-h";
export var normal = "_qw-7";
export var replyCard = "_qw-f";
export var subtleButton = "_qw-1";
export var subtleButtonIconContainer = "_qw-2";
export var toggleViewRepliesButton = "_qw-c";
export var wrappingText = "_qw-g";